import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';
import SwiperCore, { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { BREAKPOINTS } from '../../../constants/breakpoints';
import Link from '../../Link';

SwiperCore.use([Autoplay, EffectFade]);

const CardImageBasedXLargeSwiper = ({
  carousel,
  className,
  setRealIndex,
  setSwiper,
}) => {
  return (
    <Swiper
      autoplay={{
        delay: 5000,
        disableOnInteraction: true,
        waitForTransition: false,
      }}
      breakpoints={{
        [BREAKPOINTS.desktopXS]: {
          shortSwipes: false,
          simulateTouch: true,
          threshold: 200,
          touchStartPreventDefault: false,
        },
      }}
      effect="fade"
      fadeEffect={{
        crossFade: true,
      }}
      loop
      loopPreventsSlide={false}
      onSlideChange={(swiper) => setRealIndex(swiper.realIndex)}
      onSwiper={(swiper) => {
        setSwiper(swiper);
        setRealIndex(swiper.realIndex);
      }}
      speed={500}
    >
      {carousel.map((slide) => {
        return (
          <SwiperSlide key={slide.id}>
            <Link to={slide.url}>
              <GatsbyImage
                alt={slide.title}
                className={className}
                image={getImage(slide.image)}
              />
            </Link>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

CardImageBasedXLargeSwiper.propTypes = {
  carousel: PropTypes.array,
  className: PropTypes.string,
  setRealIndex: PropTypes.func,
  setSwiper: PropTypes.func,
};

export default CardImageBasedXLargeSwiper;
